import { ApplicationConfig, LOCALE_ID, inject, provideAppInitializer } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors, HttpClient } from '@angular/common/http';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideNativeDateAdapter } from '@angular/material/core';
import ptBr from '@angular/common/locales/pt';

import { provideEnvironmentNgxMask } from 'ngx-mask';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { TranslateLoader, provideTranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthService } from './core/services';
import { cookieInterceptor } from './core/interceptors/cookie.interceptor';
import { requestErrorInterceptor } from './core/interceptors/request-error.interceptor';
import { responseBodyInterceptor } from './core/interceptors/response-body.interceptor';

import { routes } from './app.routes';

registerLocaleData(ptBr);

class CustomTranslateLoader implements TranslateLoader {
  constructor(private http: HttpClient) {}

  getTranslation(lang: string): Observable<any> {
    return this.http.get(`/assets/i18n/${lang}.json`).pipe(
      catchError(() => {
        return of({});
      })
    );
  }
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideClientHydration(),
    provideAnimations(),
    provideHttpClient(
      withInterceptors([cookieInterceptor, requestErrorInterceptor, responseBodyInterceptor])
    ),
    provideNativeDateAdapter(),
    provideEnvironmentNgxMask(),
    { provide: LOCALE_ID, useValue: 'pt' },
    provideAnimationsAsync(),
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline' },
    },
    provideTranslateService({
      defaultLanguage: 'pt',
      loader: {
        provide: TranslateLoader,
        useClass: CustomTranslateLoader,
        deps: [HttpClient],
      },
    }),
    provideAppInitializer(() => {
      const initializerFn = (
        (authService: AuthService) => () =>
          authService.secureLogin()
      )(inject(AuthService));
      return initializerFn();
    }),
  ],
};
